<script setup>
import { computed, ref } from 'vue';
import Avatar from 'next/avatar/Avatar.vue';

// Checkbox list of agents with a filter. v-model: array of user ids.
const props = defineProps({
  people: { type: Array, required: true },
  exclude: { type: Array, default: () => [] },
  placeholder: { type: String, default: '' },
});

const selected = defineModel({ type: Array, default: () => [] });
const filter = ref('');

const visible = computed(() =>
  props.people
    .filter(person => !props.exclude.includes(person.id))
    .filter(person =>
      person.name.toLowerCase().includes(filter.value.toLowerCase())
    )
);

const toggle = id => {
  selected.value = selected.value.includes(id)
    ? selected.value.filter(item => item !== id)
    : [...selected.value, id];
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <input
      v-model="filter"
      type="text"
      class="!mb-0"
      :placeholder="placeholder"
    />
    <ul class="flex flex-col max-h-56 overflow-y-auto">
      <li v-for="person in visible" :key="person.id">
        <label
          class="flex items-center gap-2 px-2 py-1.5 rounded-md cursor-pointer hover:bg-n-alpha-1"
        >
          <input
            type="checkbox"
            :checked="selected.includes(person.id)"
            @change="toggle(person.id)"
          />
          <Avatar
            :name="person.name"
            :src="person.thumbnail || ''"
            :size="20"
            rounded-full
          />
          <span class="text-sm text-n-slate-12">{{ person.name }}</span>
        </label>
      </li>
    </ul>
  </div>
</template>
